const units = ['B', 'KB', 'MB', 'GB'];

export const formatFileSize = (size: number): string => {
  if (size === 0) {
    return '0 B';
  }

  const index = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1);
  const value = size / 1024 ** index;

  return `${value.toFixed(value >= 10 || index === 0 ? 0 : 1)} ${units[index]}`;
};
